// import React from 'react';
// import styled from 'styled-components';
// import { Fade } from 'react-awesome-reveal';
// import KidsCodeAndTechPage from './KidsCodeAndTechPage';
// import KidsCodePageHero from './KidsCodePageHero';
// import kd01 from '../Images/kd01.png';

// const PageContainer = styled.div`
//   background-color: #ffffff;
//   color: #1a1a1a;
//   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//   overflow-x: hidden;
//   padding: 0;
//   margin: 0;
//   width: 100%;
//   margin-top: 50px;
// `;

// const Section = styled.section`
//   padding: 10px;
//   margin: 10px auto;
//   max-width: 1200px;
// `;

// const HeroSection = styled(Section)`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   text-align: center;
//   gap: 10px;
//   padding: 10px;
// `;

// const Title = styled.h1`
//   font-size: 32px;
//   color: #111827;
//   margin: 0 0 10px 0;
//   line-height: 1.2;
//   word-break: break-word;
// `;

// const Subtitle = styled.p`
//   font-size: 16px;
//   color: #4b5563;
//   margin: 0 0 10px 0;
//   max-width: 700px;
//   word-break: break-word;
// `;

// const Button = styled.button`
//   background-color: #4f46e5;
//   color: #ffffff;
//   border: none;
//   padding: 8px 16px;
//   font-size: 14px;
//   font-weight: 600;
//   border-radius: 4px;
//   cursor: pointer;
//   margin: 5px;
//   transition: background 0.2s;

//   &:hover {
//     background-color: #4338ca;
//   }
// `;

// const StyledImage = styled.img`
//   width: 100%;
//   height: 250px;
//   object-fit: cover;
//   border-radius: 6px;
//   border: 1px solid #e5e7eb;
// `;

// const CardGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
//   gap: 10px;
//   margin: 10px 0;
// `;

// const Card = styled.div`
//   background: #ffffff;
//   border: 1px solid #e5e7eb;
//   padding: 10px;
//   border-radius: 6px;
//   display: flex;
//   flex-direction: column;
//   gap: 10px;
// `;

// const CardTitle = styled.h3`
//   font-size: 18px;
//   color: #1f2937;
//   margin: 0;
// `;

// const CardText = styled.p`
//   font-size: 14px;
//   color: #4b5563;
//   margin: 0;
//   word-break: break-word;
// `;

// const SectionHeader = styled.h2`
//   font-size: 26px;
//   background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   text-align: center;
//   margin: 12px 0;
//   font-weight: 800;
//   letter-spacing: -0.5px;
//   filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.08));
// `;

// export default function EasterCodingAndAIIPage() {
//   return (
//     <PageContainer>
//       <KidsCodePageHero />
//       <Fade triggerOnce>
//         <HeroSection>
//           <Title>Exciting Easter Coding & AI Camp for Kids & Teens</Title>
//           <Subtitle>Make this Easter holiday unforgettable with an interactive adventure in coding, artificial intelligence, and tech creation. Designed for ages 6–16.</Subtitle>
//           <Button>Secure Your Easter Slot</Button>
//           <StyledImage src={kd01} alt="Easter coding and AI camp kids" />
//         </HeroSection>
//       </Fade>

//       <Fade triggerOnce>
//         <Section>
//           <SectionHeader>What Kids Will Build This Easter</SectionHeader>
//           <CardGrid>
//             <Card>
//               <CardTitle>Spring-Themed Games & AI Bots</CardTitle>
//               <CardText>Students learn logic programming and machine learning fundamentals to design fun festive games and intelligent assistant bots.</CardText>
//             </Card>
//             <Card>
//               <CardTitle>Creative Web Pages</CardTitle>
//               <CardText>Empower young creators to build responsive web apps and colorful digital storyboards showcasing their holiday projects.</CardText>
//             </Card>
//             <Card>
//               <CardTitle>Smart Gadgets & AI Prompts</CardTitle>
//               <CardText>Explore introductory robotics logic and prompt engineering concepts to bring smart automated designs to life.</CardText>
//             </Card>
//           </CardGrid>
//         </Section>
//       </Fade>

//       <Fade triggerOnce>
//         <Section>
//           <SectionHeader>Easter Camp Highlights & Schedule</SectionHeader>
//           <CardGrid>
//             <Card>
//               <CardTitle>Fast-Paced & Engaging</CardTitle>
//               <CardText>Short holiday, maximum impact! Every session is packed with hands-on coding and AI creation.</CardText>
//             </Card>
//             <Card>
//               <CardTitle>Flexible Learning Options</CardTitle>
//               <CardText>Choose between immersive onsite classes or convenient live online instructor-led sessions.</CardText>
//             </Card>
//             <Card>
//               <CardTitle>Easter Showcase Day</CardTitle>
//               <CardText>Family and friends are invited to view the amazing tech projects built by our young innovators.</CardText>
//             </Card>
//           </CardGrid>
//         </Section>
//       </Fade>

//       <Fade triggerOnce>
//         <Section style={{ textAlign: 'center', background: '#f8f9fa', padding: '20px', borderRadius: '6px' }}>
//           <SectionHeader>Give Your Child an Inspiring Easter Break</SectionHeader>
//           <Subtitle style={{ margin: '0 auto 10px auto' }}>
//             Cohort sizes are restricted to ensure dedicated mentorship and guidance. Reserve a spot today!
//           </Subtitle>
//           <Button>Enroll in Easter Coding & AI</Button>
//         </Section>
//       </Fade>
//     </PageContainer>
//   );
// }





import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import KidsCodeAndTechPage from './KidsCodeAndTechPage';
import KidsCodePageHero from './KidsCodePageHero';
import kd02 from '../Images/kd02.jpg';
import { useNavigate } from 'react-router-dom';
import ProgramPricing from './ProgramPricing';

const PageContainer = styled.div`
  background-color: #fcf8f2;
  color: #1a1a1a;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
  width: 100%;
  margin-top: 50px;
`;

const Section = styled.section`
  padding: 10px;
  margin: 10px auto;
  max-width: 1200px;
`;

const HeroSection = styled(Section)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 15px;
  padding: 15px 10px;
  background: #ffffff;
  border-radius: 12px;
  border: 2px dashed #f59e0b;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.08);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const EasterBadge = styled.span`
  background: #fef3c7;
  color: #d97706;
  font-size: 12px;
  font-weight: 800;
  padding: 4px 12px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border: 1px solid #fde68a;
`;

const Title = styled.h1`
  font-size: 32px;
  color: #111827;
  margin: 0;
  line-height: 1.2;
  font-weight: 900;
  word-break: break-word;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #4b5563;
  margin: 0;
  line-height: 1.4;
  word-break: break-word;
`;

const Button = styled.button`
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);

  &:hover {
    background: linear-gradient(135deg, #d97706, #b45309);
    transform: translateY(-2px);
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #fde68a;
`;

const StepGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
  margin: 10px 0;
`;

const StepCard = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  padding: 15px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  border-bottom: 4px solid #f59e0b;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-3px);
  }
`;

const StepNumber = styled.div`
  width: 28px;
  height: 28px;
  background: #fef3c7;
  color: #d97706;
  font-weight: 800;
  font-size: 14px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
`;

const CardTitle = styled.h3`
  font-size: 18px;
  color: #1f2937;
  margin: 0;
  font-weight: 700;
`;

const CardText = styled.p`
  font-size: 14px;
  color: #4b5563;
  margin: 0;
  word-break: break-word;
  line-height: 1.4;
`;

const SectionHeader = styled.h2`
  font-size: 26px;
  background: linear-gradient(135deg, #f59e0b, #d97706, #b45309);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  margin: 12px 0;
  font-weight: 800;
  letter-spacing: -0.5px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.06));
`;

export default function EasterCodingAndAIIPage() {
 const navigate = useNavigate();
 
    return (
    <PageContainer>
      <KidsCodePageHero />
      
      <Fade triggerOnce>
        <HeroSection>
          <HeroContent>
            <EasterBadge>🐣 Spring Holiday Special</EasterBadge>
            <Title>Exciting Easter Coding & AI Camp for Kids & Teens</Title>
            <Subtitle>Make this Easter holiday unforgettable with an interactive adventure in coding, artificial intelligence, and tech creation. Designed for ages 6–16.</Subtitle>
            <Button onClick={()=>navigate('/codingapplicationfaq')}>Secure Your Easter Slot</Button>
          </HeroContent>
          <div>
            <StyledImage src={kd02} alt="Easter coding and AI camp kids" />
          </div>
        </HeroSection>
      </Fade>

      <Fade triggerOnce>
        <Section>
          <SectionHeader>What Kids Will Build This Easter</SectionHeader>
          <StepGrid>
            <StepCard>
              <StepNumber>1</StepNumber>
              <CardTitle>Spring-Themed Games & AI Bots</CardTitle>
              <CardText>Students learn logic programming and machine learning fundamentals to design fun festive games and intelligent assistant bots.</CardText>
            </StepCard>
            <StepCard style={{ borderBottomColor: '#10b981' }}>
              <StepNumber style={{ background: '#d1fae5', color: '#059669' }}>2</StepNumber>
              <CardTitle>Creative Web Pages</CardTitle>
              <CardText>Empower young creators to build responsive web apps and colorful digital storyboards showcasing their holiday projects.</CardText>
            </StepCard>
            <StepCard style={{ borderBottomColor: '#6366f1' }}>
              <StepNumber style={{ background: '#e0e7ff', color: '#4f46e5' }}>3</StepNumber>
              <CardTitle>Smart Gadgets & AI Prompts</CardTitle>
              <CardText>Explore introductory robotics logic and prompt engineering concepts to bring smart automated designs to life.</CardText>
            </StepCard>
          </StepGrid>
        </Section>
      </Fade>

      <Fade triggerOnce>
        <Section>
          <SectionHeader>Easter Camp Highlights & Schedule</SectionHeader>
          <StepGrid>
            <StepCard style={{ borderBottomColor: '#ec4899' }}>
              <StepNumber style={{ background: '#fce7f3', color: '#db2777' }}>⚡</StepNumber>
              <CardTitle>Fast-Paced & Engaging</CardTitle>
              <CardText>Short holiday, maximum impact! Every session is packed with hands-on coding and AI creation.</CardText>
            </StepCard>
            <StepCard style={{ borderBottomColor: '#0ea5e9' }}>
              <StepNumber style={{ background: '#e0f2fe', color: '#0284c7' }}>💻</StepNumber>
              <CardTitle>Flexible Learning Options</CardTitle>
              <CardText>Choose between immersive onsite classes or convenient live online instructor-led sessions.</CardText>
            </StepCard>
            <StepCard style={{ borderBottomColor: '#8b5cf6' }}>
              <StepNumber style={{ background: '#ede9fe', color: '#7c3aed' }}>🏆</StepNumber>
              <CardTitle>Easter Showcase Day</CardTitle>
              <CardText>Family and friends are invited to view the amazing tech projects built by our young innovators.</CardText>
            </StepCard>
          </StepGrid>
        </Section>
      </Fade>

      <Fade triggerOnce>
        <Section style={{ textAlign: 'center', background: '#ffffff', padding: '24px 15px', borderRadius: '10px', border: '1px solid #e5e7eb', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
          <SectionHeader style={{ marginTop: 0 }}>Give Your Child an Inspiring Easter Break</SectionHeader>
          <Subtitle style={{ margin: '0 auto 15px auto', maxWidth: '650px' }}>
            Cohort sizes are restricted to ensure dedicated mentorship and guidance. Reserve a spot today!
          </Subtitle>
          <Button onClick={()=>navigate('/codingapplicationfaq')}>Enroll in Easter Coding & AI</Button>
        </Section>
      </Fade>

      <ProgramPricing/>
    </PageContainer>
  );
}